import { SenhaModal } from "app/types/cliente/RespostaCredito";
import React, { useEffect, useState } from "react";
import { Autorizar, ModalPermissaoSenha } from "./ModalPermissaoSenha";


export type ModalPermissaoSenhaContainerProps = {
    exibirModal: boolean;
    senhaModal: SenhaModal;
    onClose:() => void;
    onAutorizar: (autorizar: Autorizar) => void;
}


export const ModalPermissaoSenhaContainer = (props:ModalPermissaoSenhaContainerProps) => {

    const [acaoEnviarEmail, setAcaoEnviarEmail] = useState<boolean>();


    useEffect(() => {
    }, [])

    return (
        <>
            {
                props.exibirModal &&
                <ModalPermissaoSenha 
                    senhaModal={props.senhaModal}
                    onAutorizar={props.onAutorizar}
                    onClose={props.onClose}
                />
            }
        </>
    );
}